<template>
  <div style="height:calc(100% - 220px);">
    <v-layout class="blue-grey lighten-5" id="pc-sort-box" wrap row >
      <v-flex xs5 sm5 class="pa-2 search">
        <v-text-field
        append-icon="search"
        single-line
        hide-details
        v-model="listSearch"
      ></v-text-field>
      </v-flex>

      <v-flex xs5 sm7>
        <organization-pc-add-btn
        ref="organizationAdd"
        @reload="getOrganizationPcs"
        />
      </v-flex>

    </v-layout>

    <!-- メイン -->
    <v-container fill-height class="pa-0">
    <v-layout id="pc-list-main" wrap row >

      <!-- 左半分 -->
      <v-flex xs12 sm5 class="white" id="pc-list">

        <v-data-table
          :items="filteredPcs"
          class=""
          select-all
          disable-initial-sort
          hide-headers
          item-key="locationId"
        >

          <!-- 顧客リストコンテンツ -->
          <template slot="items" slot-scope="props">
            <tr @click="selectOrganization(props.item)">
              <td class="text-xs-left body-1">{{ props.item.name}}</td>
              <td class="text-xs-right caption grey--text text--darken-2">
                  {{props.item.created}}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>

      <!-- 右半分 -->
      <v-flex xs12 sm7 id="pc-detail" class="grey lighten-3">

        <!--  基本情報  -->
          <v-card class="ma-2 pl-3">
            <!--  編集ボタン  -->
          <div class="setting">
            <v-menu left offset-y :disabled="settingBtnDisabled">
              <v-btn  small flat icon slot="activator">
                <v-icon class="caption grey--text">settings</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile @click="editOrganization()">
                  {{$t('btn.edit')}}
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>

            <v-card-title class="align-baseline pa-0">
              <h2 id="pc-name">{{pc.name}}</h2>
              <span class="caption">{{pc.description}}</span>
              <v-spacer></v-spacer>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>
              <v-layout>
                <v-flex lg12 class="pc-info pl-2">
                  <h4>{{$t('account.incharge')}}</h4>
                  {{pc.contact}}
                </v-flex>
              </v-layout>

              <v-layout mt-3>
                <v-flex lg12 class="pc-info pl-2">
                  <h4>{{$t('account.tel')}}</h4>
                  {{pc.phone}}
                </v-flex>
              </v-layout>

              <v-layout mt-3>
                <v-flex lg12 class="pc-info pl-2">
                  <h4>{{$t('account.email')}}</h4>
                  {{pc.email}}
                </v-flex>
              </v-layout>

              <v-layout mt-3>
                <v-flex lg12 class="pc-info pl-2">
                  <h4>{{$t('aplix-use-only.customer-category')}}</h4>
                  {{pc.customerCategoryName}}
                </v-flex>
              </v-layout>

            </v-card-text>
          </v-card>
          <v-data-table
            :headers="listHeaders"
            :items="accountList"
            item-key="username"
            class="elevation-1 account-list"
          >

            <!-- コンテンツ -->
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{ props.item.username }}</td>
                <td>{{ props.item.email }}</td>
                <td>
                  <div v-if="props.item.user_status===2">
                    <v-menu left offset-y>
                      <v-btn icon slot="activator">
                        <v-icon class="caption">build</v-icon>
                      </v-btn>
                      <v-list>
                        <v-list-tile @click="resendMail(props.item.id)">
                          {{$t('btn.resend')}}
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
      </v-flex>

        <organization-edit-btn
        ref="organizationEditDialog"
        @child-action="getOrganizationPcs"
        />

    </v-layout>

    <!-- メッセージ スナックバー -->
    <v-snackbar
      v-model="showSnackbar"
      absolute top right
      :color="snackbarColor"
      :timeout="snackbarTimeout"
    >
    {{snackbarMessage}}
    </v-snackbar>

  </v-container>

  </div>

</template>


<script>
import http from '@/utils/http.js'
import organizationEditBtn from '@/components/OrganizationEdit.vue'
import validate from '@/utils/validate.js'
import organizationPcAddBtn from '@/components/AccountOrganizationPcAdd'
import utils from '@/utils/utils.js'

export default {
  components: {
    organizationEditBtn,
    organizationPcAddBtn
  },
  data () {
    return {
      organizationPcs: [],
      accountList: [],
      listHeaders: [
        {text: this.$t('account.label-username'), value: 'username'},
        {text: this.$t('account.label-useremail'), value: 'email'}
      ],
      settingBtnDisabled: true,
      listSearch: '',
      pc: {
        name: '',
        contact: '',
        description: '',
        phone: '',
        email: '',
        customerCategoryName: ''
      },
      // rule
      emailRules: [
        v => validate.emailFormat(v) ||
           this.$t('account.vali-email-format')
      ],
      phoneRules: [
        v => validate.phoneFormat(v) ||
           this.$t('account.vali-phone-format'),
        v => v.length <= 128 || this.$t('account.vali-phone-length')
      ],

      // snackbar
      showSnackbar: false,
      snackbarMessage: '',
      snackbarColor: '',
      snackbarTimeout: 4000,

      selectedOrganization: [] // 選択中の情報を保持
    }
  },
  computed: {
    filteredPcs () {
      return this.organizationPcs.filter(a => {
        return a.name.toLowerCase().includes(this.listSearch.toLowerCase())
      })
    }
  },
  methods: {
    init () {
      this.getOrganizationPcs()
    },
    getLocations () {
      http.request('get', '/service2/dashboard/api/Organizations/locationList')
        .then(response => {
          const data = response.data
          console.log(data)
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get location list failed. (' + data.result + ')')
            return
          }
          this.locations = data.locations
          this.initDisplayLocations = data.locations
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    },
    editOrganization () {
      this.$refs.organizationEditDialog.startDialog(this.selectedOrganization)
    },
    selectOrganization (param) {
      // 選択状態のダイアログを保持
      this.selectedOrganization = param
      this.settingBtnDisabled = false
      // 表示情報をバインド
      this.pc.description = param.description
      this.pc.name = param.name
      this.pc.username = param.username
      this.pc.useremail = param.useremail
      this.pc.contact = param.contact
      this.pc.phone = param.phone
      this.pc.email = param.email
      console.log(param)
      this.pc.customerCategoryName = utils.setNameCustomerCategory(this.$t, param.customerCategoryName, param.customer_category_id)
      // アドミンアカウント情報を表示
      this.getAccounts(param.id)
    },
    addOrganizationPc () {
      this.$refs.organizationPcAddBtn.addOrganizationPc()
    },
    getOrganizationPcs () {
      http.request('get', '/service2/dashboard/api/Organizations/pcList/')
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get organization list failed. (' + data.result + ')')
            return
          }
          delete data.result
          this.organizationPcs = data.pcOrganizations
          // 今表示しているデータを最新の情報で更新
          if (this.selectedOrganization.id) {
            // IDで絞り込み
            var nowSelectedOrganization = this.organizationPcs.filter(x => x.id === this.selectedOrganization.id)
            if (nowSelectedOrganization) {
              this.selectOrganization(nowSelectedOrganization[0])
            }
          }
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    },
    getAccounts (organizationId) {
      // Administrator権限ユーザーのみ取得
      http.request('get', '/service2/dashboard/api/organizations/accountList/' + organizationId + '/2')
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get account list failed. (' + data.result + ')')
            return
          }
          // 表示用の加工
          this.accountList = []
          if (data.accounts.length === 0) {
            return
          }
          for (var key in data.accounts) {
            if (data.accounts[key].roles[0].id === '2') {
              this.accountList.push({
                id: data.accounts[key].id,
                username: data.accounts[key].username,
                email: data.accounts[key].email,
                user_status: data.accounts[key].user_status
              })
            }
          }
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    },
    showMessage (result, msg) {
      switch (result) {
        case 'error':
          this.snackbarMessage = msg
          this.snackbarColor = 'red lighten-3'
          this.snackbarTimeout = 6000
          this.showSnackbar = true
          break
        case 'success':
          this.snackbarMessage = msg
          this.snackbarColor = 'teal lighten-2'
          this.snackbarTimeout = 3000
          this.showSnackbar = true
          break
        default:
          return
      }
    },
    resendMail (accountId) {
      http.request('post', '/service2/dashboard/api/accounts/inviteMail', {'accountId': accountId})
      .then(response => {
        if (response.data.result === -34) {
          this.showMessage('error', this.$t('account.already-account'))
        } else if (response.data.result === 0) {
          this.showMessage('success', this.$t('account.success-dialog'))
        } else {
          this.showMessage('error', this.$t('account.fail-dialog'))
        }
      })
      .catch(error => {
        console.log(error)
        this.showMessage('error', this.$t('account.fail-dialog'))
      })
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style>

#pc-list {
  height: 100%;
  overflow: auto;
}
#pc-list > div {
  display: flex;
  flex-flow: column-reverse;
}
#pc-list > div .table__overflow {
  border-top: 1px solid rgba(0,0,0,.12);
}
/* 検索窓のカスタマイズ */
.search .input-group {
  padding:0px;
}
.search  .input-group__input {
  padding: 2px;
  background-color: #DDD;
  border-radius:5px;
}
.search .input-group__details:before {
  background-color: rgba(0,0,0,0)!important;
}

#pc-name {
  display: inline-block;
  height: 3em;
  line-height: 3.2em;
  margin-right: 15px;
}

.pc-info {
  height: 3em;
  border-left:3px solid #CCC;
}

#pc-detail {
  overflow-y: auto;
}

.account-list {
  margin-left:10px;
  margin-right:10px;
}

.setting {
  text-align: right;
  margin-bottom: -50px;
}

</style>



// WEBPACK FOOTER //
// AccountOrganizationPcList.vue?f5fb3418